import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonComponentsModule } from '../../common/common.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import {ColorPickerModule} from 'ngx-color-picker';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {ServiceConfigurationListComponent} from './service-configuration-list/service-configuration-list.component';
import {ServiceConfigurationApiComponent} from './service-configuration-api/service-configuration-api.component';
import {ServiceConfigurationRuntimeComponent} from './service-configuration-runtime/service-configuration-runtime.component';
import {ServiceConfigurationInMemoryComponent} from './service-configuration-inMemory/service-configuration-inMemory.component';
import {ServiceConfigurationSchedulerComponent} from './service-configuration-scheduler/service-configuration-scheduler.component';
import { ServiceConfigurationBatcherComponent } from './service-configuration-batcher/service-configuration-batcher.component';
import {InteractionQueueConfigComponent} from './interaction-queue-config/interaction-queue-config.component';
import { CustomInteractionQueueConfigListComponent } from './custom-interaction-queue-config-list/custom-interaction-queue-config-list.component';
import {EditQueueColorModalComponent} from './common/edit-queue-color-modal/edit-queue-color-modal.component';
import {EditQueueColumnModalComponent} from './common/edit-queue-column-modal/edit-queue-column-modal.component';
import {QueueColumnsPreviewModalComponent} from './common/queue-columns-preview-modal/queue-columns-preview-modal.component';
import {HumanInteractionModule} from '../HumanInteraction/human-interaction.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CustomInteractionQueueConfigComponent } from './custom-interaction-queue-config/custom-interaction-queue-config.component';
import { configRouting } from './configuration.routing';
import { GlobalVariablesComponent } from './global-variables/global-variables.component';
import { GlobalVariableModalComponent } from './global-variables/global-variable-modal/global-variable-modal.component';
import {DriverUpdateListComponent} from './driver-update-list/driver-update-list.component';
import { GlobalVariableGroupsComponent } from './global-variable-groups/global-variable-groups.component';
import { GlobalVariableGroupModalComponent } from './global-variable-groups/global-variable-group-modal/global-variable-group-modal.component';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {MetadataStructureModalComponent} from './metadata-structure-list/metadata-structure-modal/metadata-structure-modal.component';
import {MetadataStructureListComponent} from './metadata-structure-list/metadata-structure-list.component';
import {UserMetadataAdminComponent} from './user-metadata-admin/user-metadata-admin.component';
import {UserMetadataAdminModalComponent} from './user-metadata-admin/user-metadata-admin-modal/user-metadata-admin-modal.component';
import {EditQueueOverflowModalComponent} from './common/edit-queue-overflow-modal/edit-queue-overflow-modal.component';
import {EditQueueMetadataModalComponent} from './common/edit-queue-metadata-modal/edit-queue-metadata-modal.component';
import {DistributionCustomInteractionComponent} from './distribution-custom-interaction/distribution-custom-interaction.component';
import { PoolsComponent } from './pools/pools.component';
import { SystemFlowComponent } from './system-flow/system-flow.component';
import { SystemFlowModalComponent } from './system-flow/system-flow-modal/system-flow-modal.component';
import { SystemFlowImportComponent } from './system-flow/system-flow-import/system-flow-import.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PoolsModalComponent } from './pools/pools-modal/pools-modal.component';
import {ServiceConfigurationWebClientComponent} from './service-configuration-webClient/service-configuration-webClient.component';
import { DataExtractionLayoutComponent } from './data-extraction-layout/data-extraction-layout.component';
import { ExtractionLayoutModalComponent } from './data-extraction-layout/extraction-layout-modal/extraction-layout-modal.component';
import {SchedulingComponent} from './scheduling/scheduling.component';
import { ExtractionSchedulingModalComponent } from './scheduling/extraction-scheduling-modal/extraction-scheduling-modal.component';
import {TaskMonitoringComponent} from './task-monitoring/task-monitoring.component';
import { ErrorMessageModalComponent } from './task-monitoring/error-message-modal/error-message-modal.component';


@NgModule({
  declarations: [
    ServiceConfigurationListComponent,
    ServiceConfigurationApiComponent,
    ServiceConfigurationRuntimeComponent,
    ServiceConfigurationInMemoryComponent,
    ServiceConfigurationSchedulerComponent,
    ServiceConfigurationBatcherComponent,
    ServiceConfigurationWebClientComponent,
    InteractionQueueConfigComponent,
    CustomInteractionQueueConfigListComponent,
    EditQueueColumnModalComponent,
    EditQueueColorModalComponent,
    QueueColumnsPreviewModalComponent,
    CustomInteractionQueueConfigComponent,
    GlobalVariablesComponent,
    GlobalVariableModalComponent,
    DriverUpdateListComponent,
    GlobalVariableGroupsComponent,
    GlobalVariableGroupModalComponent,
    MetadataStructureListComponent,
    MetadataStructureModalComponent,
    UserMetadataAdminComponent,
    UserMetadataAdminModalComponent,
    EditQueueOverflowModalComponent,
    EditQueueMetadataModalComponent,
    DistributionCustomInteractionComponent,
    PoolsComponent,
    PoolsModalComponent,
    SystemFlowComponent,
    SystemFlowModalComponent,
    SystemFlowImportComponent,
    DataExtractionLayoutComponent,
    ExtractionLayoutModalComponent,
    SchedulingComponent,
    ExtractionSchedulingModalComponent,
    TaskMonitoringComponent,
    ErrorMessageModalComponent
  ],
  entryComponents: [
    ServiceConfigurationListComponent,
    ServiceConfigurationApiComponent,
    ServiceConfigurationRuntimeComponent,
    ServiceConfigurationInMemoryComponent,
    ServiceConfigurationSchedulerComponent,
    ServiceConfigurationBatcherComponent,
    ServiceConfigurationWebClientComponent,
    InteractionQueueConfigComponent,
    CustomInteractionQueueConfigListComponent,
    EditQueueColumnModalComponent,
    EditQueueColorModalComponent,
    QueueColumnsPreviewModalComponent,
    GlobalVariablesComponent,
    GlobalVariableModalComponent,
    DriverUpdateListComponent,
    GlobalVariableGroupsComponent,
    GlobalVariableGroupModalComponent,
    MetadataStructureListComponent,
    MetadataStructureModalComponent,
    UserMetadataAdminComponent,
    UserMetadataAdminModalComponent,
    EditQueueOverflowModalComponent,
    EditQueueMetadataModalComponent,
    DistributionCustomInteractionComponent,
    PoolsComponent,
    PoolsModalComponent,
    SystemFlowComponent,
    SystemFlowModalComponent,
    SystemFlowImportComponent,
    DataExtractionLayoutComponent,
    ExtractionLayoutModalComponent,
    SchedulingComponent,
    ExtractionSchedulingModalComponent,
    TaskMonitoringComponent,
    ErrorMessageModalComponent
  ],
  imports: [
    CommonModule,
    CommonComponentsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    ColorPickerModule,
    HumanInteractionModule,
    DragDropModule,
    configRouting,
    TabsModule.forRoot(),
    TooltipModule.forRoot()
  ]
})
export class ConfigurationModule { }
